import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const menu = () => theme => css`
  min-width: ${rem(185)};
  color: ${theme.color.monochrome.black};
  border-radius: ${rem(8)};

  [role='menuitem'] {
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
    min-height: ${rem(40)};
    // Override hover styles in menu item, excluding header
    &[tabindex='0']:hover,
    &.highlighted {
      background-color: ${theme.color.monochrome.superLight} !important;
    }
  }

  a {
    color: ${theme.color.monochrome.black};
  }
`

const emoji = theme => css`
  vertical-align: middle;
  font-size: ${theme.fontSize.x2large};
`

const progressCircle = css`
  position: absolute;
  top: ${rem(10)};
  right: ${rem(6)};
  z-index: 1;
`

const badge = theme => css`
  font-size: ${theme.fontSize.xsmall};
  font-weight: ${theme.fontWeight.medium};
  line-height: 1;
  height: ${rem(19)};
  min-width: ${rem(19)};
  border-radius: ${rem(10)};
  background-color: ${theme.color.primary.info};
  color: ${theme.color.monochrome.white};
  padding: ${rem(3)} ${rem(7)} ${rem(4)};
`

export const styles = {
  menu,
  emoji,
  progressCircle,
  badge,
}
